import axios from 'axios';
import { buildApiUrl } from '../config/api';


export const TipoPostulacionService = {
    getTipoPostulacion: async (token) => {
        try {
            const response = await axios.get(
                buildApiUrl('/api/ajustes/tipopostulacion'),
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            return response.data.tipoPostulacion;
        } catch (error) {
            console.error('Error en TipoPostulacionService:', error);
            throw error;
        }
    },
};
